import { MaskedLines, Reveal } from "./Reveal";

export const PageHero = ({ overline, lines, description, image }) => (
  <section className="relative pt-36 pb-16 lg:pt-44 lg:pb-24 overflow-hidden">
    {image && (
      <>
        <img src={image} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-base/70 via-base/85 to-base" aria-hidden="true" />
      </>
    )}
    <div className="relative max-w-7xl mx-auto px-5 lg:px-10">
      <Reveal>
        <p className="overline-label flex items-center gap-3">
          <span className="inline-block w-8 h-px bg-forest-mid" aria-hidden="true" />
          {overline}
        </p>
      </Reveal>
      <h1 className="h-display text-3xl sm:text-4xl lg:text-5xl mt-5 text-white max-w-4xl">
        <MaskedLines lines={lines} onLoad baseDelay={0.15} />
      </h1>
      {description && (
        <Reveal delay={0.35}>
          <p className="mt-6 max-w-2xl text-cement text-base sm:text-lg leading-relaxed">{description}</p>
        </Reveal>
      )}
    </div>
    <div className="absolute inset-x-0 bottom-0 h-px bg-steel" aria-hidden="true" />
  </section>
);
